<button (click)="close()" class="close" aria-label="Close" type="button">
  <span class="far fa-times"></span>
</button>
<h4>{{data.title}}</h4>
<a *ngIf="data.link" target="_blank" [href]="data.link">{{data.linkText}}</a>
